export const ACOES_REQUEST = "ACOES_REQUEST";
export const ACOES_SUCCESS = "ACOES_SUCCESS";
export const ACOES_FAIL = "ACOES_FAIL";
